export const CSRF_COOKIE_NAME = 'csrf_access_token';
export const CSRF_HEADER_NAME = 'X-CSRF-TOKEN';
export const THEME_STORAGE_KEY = 'cirun:theme';
export const MOBILE_BREAKPOINT_PX = 1024;
export const QUERY_STALE_TIME_MS = 30_000;
export const QUERY_RETRY_COUNT = 1;
export const AUTH_EXPIRED_EVENT = 'auth:expired';
